<template>
  <div class="signature-view">
    <x-upload
      type="image"
      imageAlign="start"
      :fileCount="1"
      :fileSize="5 * 1024"
      :imageViewWidth="150"
      :imageViewHeight="90"
      v-model="inputValue"
    >
    </x-upload>
    <div class="signature-btns">
      <el-button size="small" type="default" @click="showDrawClick"> 签名 </el-button>
    </div>
    <el-dialog
      title="签名面板"
      :modal="true"
      :append-to-body="true"
      :visible.sync="showDraw"
      width="580px"
    >
      <div class="signature-draw" v-loading="isSaveing">
        <div style="margin-bottom: 10px">
          {{ placeholder }}
        </div>
        <canvas
          ref="canvas"
          v-if="showDraw"
          width="500"
          height="300"
          @mousedown="startDrawing"
          @mousemove="drawContent"
          @mouseup="stopDrawing"
        ></canvas>
      </div>
      <span slot="footer" class="dialog-footer">
        <div>
          <el-button size="small" type="default" @click="cancelClick"> 取消 </el-button>
          <el-button size="small" type="default" @click="clearCanvasClick">
            清除画布
          </el-button>
          <el-button size="small" type="primary" @click="saveSignatureClick">
            保存签名
          </el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    lineWidth: {
      type: Number,
      default: 5,
    },
    lineColor: {
      type: String,
      default: "#000000",
    },
    placeholder: {
      type: String,
      default: "请书写",
    },
    canvasWidth: {
      type: Number,
      default: 500,
    },
    canvasHeight: {
      type: Number,
      default: 300,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      showDraw: false,
      isSaveing: false, // 是否正在保存
      isDrawing: false, // 是否正在绘制
      inputValue: "",
    };
  },
  watch: {
    value() {
      this.initValue();
    },
    canvasWidth() {
      this.initCanvas();
    },
    canvasHeight() {
      this.initCanvas();
    },
    inputValue() {
      this.$emit("change", this.inputValue);
    },
  },
  mounted() {
    this.initValue();
    this.initCanvas();
  },
  methods: {
    initValue() {
      this.inputValue = this.value;
    },
    initCanvas() {
      let canvas = this.$refs.canvas;
      if (!canvas) {
        return;
      }
      canvas.width = this.canvasWidth;
      canvas.height = this.canvasHeight;
      this.clearCanvasClick();
    },
    checkSignature(callback) {
      if (this.value) {
        callback && callback(true);
      } else {
        callback && callback(false);
        this.showDrawClick();
      }
    },
    clearCanvasClick() {
      let canvas = this.$refs.canvas;
      if (!canvas) {
        return;
      }
      let context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    },
    startDrawing(event) {
      let canvas = this.$refs.canvas;
      if (!canvas) {
        return;
      }
      let context = canvas.getContext("2d");
      const { offsetX, offsetY } = event;
      context.beginPath();
      context.moveTo(offsetX, offsetY);
      this.isDrawing = true;
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    drawContent(event) {
      let canvas = this.$refs.canvas;
      if (!canvas) {
        return;
      }
      if (!this.isDrawing) return;
      let context = canvas.getContext("2d");
      const { offsetX, offsetY } = event;
      context.lineTo(offsetX, offsetY);
      context.lineWidth = this.lineWidth;
      context.strokeStyle = this.lineColor;
      context.stroke();
    },
    cancelClick() {
      this.showDraw = false;
    },
    showDrawClick() {
      this.showDraw = true;
      this.$nextTick(() => {
        this.clearCanvasClick();
      });
    },
    // 保存
    saveSignatureClick() {
      let canvas = this.$refs.canvas;
      if (!canvas) {
        return;
      }
      this.isSaveing = true;
      this.requestApi(
        "biz.customer.upload.file",
        {
          type: "signature",
          fileBase64: canvas.toDataURL().split(",")[1],
          fileName: "signature.png",
        },
        {
          timeout: 1000 * 60 * 60 * 24,
          showError: true,
        }
      )
        .then((resp) => {
          if (resp.data && resp.data.url) {
            return resp.data.url;
          } else {
            throw resp.err || resp.msg || "上传失败";
          }
        })
        .then((url) => {
          this.isSaveing = false;
          this.showDraw = false;
          this.$emit("change", url);
        })
        .catch((err) => {
          this.isSaveing = false;
          throw err;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.signature-view {
  border-radius: 5px;
  border: 1px solid #dedede;
}

.signature-draw {
  margin-left: 20px;
  margin-right: 20px;
  canvas {
    border: 1px solid #dedede;
    border-radius: 5px;
  }
}

.signature-btns {
  margin: 20px;
}

.signature-preview {
  border: 1px solid #dedede;

  img {
    width: auto;
    height: auto;
  }
}
</style>
